import { createRouter, createWebHistory } from "vue-router";
export type { RouteRecordNameGeneric, RouterOptions, Router } from "vue-router";
import { routes } from "./routes";
import { initializeMiddlewares } from "./middlewares";

export const router = createRouter({
	history: createWebHistory(),
	routes,
});

initializeMiddlewares(router);
